import React from "react";
import "./header.css";
import HeaderOption from "./headerOption"
import {Avatar} from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "./userSlice";
import SearchIcon from '@material-ui/icons/Search';
import HomeIcon from '@material-ui/icons/Home';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import ChatIcon from '@material-ui/icons/Chat';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { auth } from "./firebase";
import {logoutuser} from "./userSlice";


function Header(){
   const dispatch= useDispatch();

   const logoutOfApp= () =>{
      dispatch(logoutuser());
      auth.signOut();
   };

   const user= useSelector(selectUser);
   
    return(
       <div className="header">

           
           <div className="header_left">
                <img src="linkedin_logo.png" alt=" "/>
          
           
             <div className="header_search">
               <SearchIcon/>
               
               <input type="text"/>
             </div>
           </div>

           <div className="header_right">
           <HeaderOption Icon= {HomeIcon} title="Home"/> 
              <HeaderOption Icon= {SupervisorAccountIcon} title="My Network"/> 
              <HeaderOption Icon= {BusinessCenterIcon} title="Jobs"/> 
              <HeaderOption Icon= {ChatIcon} title="Messaging"/> 
              <HeaderOption Icon= {NotificationsIcon} title="Notifications"/> 
              <HeaderOption avatar= {user.photoURL} title={user.displayName} onClick={logoutOfApp}/>
            
           </div>
       </div>

    );
}
export default Header